import { FilterWithViewAll, TableWithActions } from '@/components';
import React, { memo } from 'react';

import { isNotNilOrEmpty } from 'ramda-adjunct';

import { useLogic } from './logic';
import { IUpdateHistoryProps } from './type';

const UpdateHistory: React.FC<IUpdateHistoryProps> = (props) => {
	const {
		initialValues,
		reduxParams,
		dataSource,
		total,
		loading,
		historyUpdateOptions,
		fetchData,
		onPageSizeChange,
		onPageChange,
		columns,
		filterRef,
		t,
		updateAreaOptions,
	} = useLogic(props);

	return (
		<div className="bg-white rounded-2xl">
			<TableWithActions
				{...{ dataSource, loading }}
				columns={columns}
				titleInDetail={t('title')}
				actionHidden
				pageSizeHidden={true}
				actionsTop={
					<FilterWithViewAll
						initialValues={initialValues}
						fetchData={fetchData}
						hideInput
						ref={filterRef}
					>
						{isNotNilOrEmpty(updateAreaOptions) ? (
							<FilterWithViewAll.SelectMasterInfo
								defaultValue=""
								name="fieldArea"
								containerClassName="w-[180px]"
								options={updateAreaOptions}
								onChange={() => {
									filterRef.current?.setFieldValue?.('fieldName', '');
								}}
							/>
						) : (
							<></>
						)}
						<FilterWithViewAll.SelectMasterInfo
							defaultValue=""
							name="fieldName"
							containerClassName="w-[180px]"
							options={historyUpdateOptions}
						/>
					</FilterWithViewAll>
				}
				onPageSizeChange={onPageSizeChange}
				onPageChange={onPageChange}
				pagination={{
					defaultPageSize: reduxParams?.pageSize,
					current: reduxParams?.page,
					pageSize: reduxParams?.pageSize,
					total,
				}}
				defaultPageSize={reduxParams?.pageSize}
				rowKey="id"
				isSearching={filterRef?.current?.isSearching}
			/>
		</div>
	);
};

export default memo(UpdateHistory);
